import styled from 'styled-components';

const DescriptiveStyle = styled.div`
	--firstSectionMargin: var(--sp32x);
	--titleMarginBottom: var(--sp7x);
	--subtitleMarginBottom: var(--sp9x);
	--subtitleMaxWidth: var(--sp200x);
	--secondSectionPaddingTopBottom: var(--sp37x) 0;
	--descriptionMaxWidth: var(--sp86x);
	--descriptionSecondSectionFirstChild: var(--sp11x);
	--listPaddingLeft: var(--sp3x);
	--listItemMarginTopBottom: var(--sp1x) 0;
	--buttonMarginTop: var(--sp9x);

	--smallImageWidth: 28.7%;
	--smallImagePaddingTop: 36.3%;
	--smallImageMarginRight: var(--sp13x);
	--bigImageWidth: 50.2%;
	--bigImagePaddingTop: 63%;
	--leftContentMarginBottom: var(--sp55x);
	--onlyFileMarginBottom: var(--sp25x);
	--smallLandscapeImagePaddingTop: 28%;

	.description-and-image-wrap {
		display: flex;
		justify-content: space-between;
		width: 100%;
		position: relative;

		.left-content {
			&.has-second-section {
				margin-bottom: var(--leftContentMarginBottom);
			}
		}

		.images-wrap {
			display: flex;
			justify-content: flex-end;
			align-items: flex-start;
			width: calc(100% - var(--descriptionMaxWidth));
			flex: 1;
			align-items: flex-end;

			&.no-second-section {
				margin: unset;
			}

			.small-img {
				width: var(--smallImageWidth);
				padding-top: var(--smallImagePaddingTop);
				margin-right: var(--smallImageMarginRight);
				margin-top: auto;

				img {
					border-radius: var(--sp2x);
				}

				&.landscape-image {
					width: calc(2 * var(--smallImageWidth));
					margin-bottom: -3%;
					padding-top: var(--smallLandscapeImagePaddingTop);

					img {
						min-width: auto !important;
						min-height: auto !important;
						width: auto !important;
						height: 100% !important;
					}
				}
			}
			.big-img {
				width: var(--bigImageWidth);
				padding-top: var(--bigImagePaddingTop);
				margin-bottom: 9%;

				img {
					border-radius: var(--sp2x);
				}
			}
		}
	}

	.lottie {
		span {
			font-weight: bolder;
		}
	}

	.second-section {
		padding: var(--secondSectionPaddingTopBottom);
		margin-top: calc(var(--sp55x) * -1);

		.section {
			margin-bottom: unset;
		}

		.malibu-end {
			margin-bottom: 0;
		}

		.title {
			margin-bottom: var(--titleMarginBottom);
		}
	}

	.second-section-descriptions-wrap {
		display: flex;
		.description-second-section {
			&:first-child {
				margin-right: var(--descriptionSecondSectionFirstChild);
			}
		}
	}

	.description {
		max-width: var(--descriptionMaxWidth);
		width: var(--descriptionMaxWidth);

		p {
			font-size: var(--p);
			font-family: var(--helvetica);
		}
		strong {
			font-family: var(--helvetica);
			font-weight: 600;
		}
		i {
			font-family: var(--helvetica);
			font-style: italic;
		}
		a {
			text-decoration: underline;
		}
		ul {
			list-style: disc;
			padding-left: var(--listPaddingLeft);
			li {
				font-size: var(--p);
				font-family: var(--helvetica);
				margin: var(--listItemMarginTopBottom);

				&:first-child {
					margin-top: 0;
				}
			}
		}
		ol {
			li {
				font-size: var(--p);
				font-family: var(--helvetica);
				margin: var(--listItemMarginTopBottom);

				&:first-child {
					margin-top: 0;
				}
			}
		}
	}

	.first-section-wrap {
		&.has-second-section {
			margin-bottom: var(--firstSectionMargin);
		}

		&.only-file {
			margin-bottom: var(--onlyFileMarginBottom);
		}

		.first-section {
			display: flex;
			flex-direction: column;
			align-items: flex-start;

			.title {
				margin-bottom: var(--titleMarginBottom);
				max-width: var(--subtitleMaxWidth); /* Same max width as subtitle */
			}

			.subtitle {
				margin-bottom: var(--subtitleMarginBottom);
				max-width: var(--subtitleMaxWidth);

				&.no-title {
					max-width: 100%;
					width: 100%;
					text-align: center;
				}
			}

			.lottie {
				margin-top: var(--buttonMarginTop);
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--titleMarginBottom: var(--sp5x);
		--subtitleMarginBottom: var(--sp7x);
		--subtitleMaxWidth: var(--sp150x);
		--secondSectionPaddingTopBottom: var(--sp28x) 0;
		--descriptionMaxWidth: var(--sp64x);
		--descriptionSecondSectionFirstChild: var(--sp10x);
		--buttonMarginTop: var(--sp7x);

		--smallImageWidth: 28.9%;
		--smallImagePaddingTop: 36.2%;
		--smallImageMarginRight: var(--sp10x);
		--bigImageWidth: 50.4%;
		--bigImagePaddingTop: 64.4%;
		--leftContentMarginBottom: var(--sp52x);
		--onlyFileMarginBottom: var(--sp22x);

		.description-and-image-wrap {
			.images-wrap {
				.big-img {
					margin-bottom: 10%;
				}
			}
		}
		.second-section {
			margin-top: calc(var(--sp52x) * -1);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--firstSectionMargin: var(--sp15x);
		--titleMarginBottom: var(--sp4x);
		--subtitleMarginBottom: var(--sp6x);
		--subtitleMaxWidth: var(--sp117x);
		--secondSectionPaddingTopBottom: var(--sp22x) 0;
		--descriptionMaxWidth: var(--sp61x);
		--descriptionSecondSectionFirstChild: var(--sp9x);
		--buttonMarginTop: var(--sp6x);

		--smallImageWidth: 28.4%;
		--smallImagePaddingTop: 35.5%;
		--smallImageMarginRight: var(--sp8x);
		--bigImageWidth: 49.6%;
		--bigImagePaddingTop: 62.2%;
		--leftContentMarginBottom: var(--sp30x);
		--onlyFileMarginBottom: var(--sp20x);

		.description-and-image-wrap {
			.images-wrap {
				margin-top: 0;
				.big-img {
					margin-bottom: 10%;
				}
			}
		}
		.second-section {
			margin-top: calc(var(--sp30x) * -1);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--firstSectionMargin: var(--sp18x);
		--titleMarginBottom: var(--sp4x);
		--subtitleMarginBottom: var(--sp6x);
		--subtitleMaxWidth: var(--sp112x);
		--secondSectionPaddingTopBottom: var(--sp18x) 0;
		--descriptionMaxWidth: var(--sp61x);
		--descriptionSecondSectionFirstChild: var(--sp9x);
		--buttonMarginTop: var(--sp6x);

		--smallImageWidth: 33.1%;
		--smallImagePaddingTop: 41.5%;
		--smallImageMarginRight: var(--sp5x);
		--bigImageWidth: 57.8%;
		--bigImagePaddingTop: 72.5%;
		--leftContentMarginBottom: var(--sp30x);
		--onlyFileMarginBottom: var(--sp17x);

		.description-and-image-wrap {
			.images-wrap {
				.big-img {
					margin-bottom: 9%;
				}
			}
		}
		.second-section {
			margin-top: calc(var(--sp30x) * -1);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--firstSectionMargin: var(--sp32x);
		--titleMarginBottom: var(--sp4x);
		--subtitleMarginBottom: var(--sp5x);
		--subtitleMaxWidth: var(--sp101x);
		--secondSectionPaddingTopBottom: var(--sp21x) 0;
		--descriptionMaxWidth: var(--sp62x);
		--descriptionSecondSectionFirstChild: var(--sp8x);
		--buttonMarginTop: var(--sp5x);

		--smallImageMarginRight: var(--sp7x);
		--leftContentMarginBottom: 0;
		--onlyFileMarginBottom: var(--sp15x);
		--smallLandscapeImagePaddingTop: 23%;

		--smallImageWidth: 40.5%;
		--smallImagePaddingTop: 35.5%;

		--bigImageWidth: 62.6%;
		--bigImagePaddingTop: 74.7%;

		.description-and-image-wrap {
			.images-wrap {
				.small-img {
					&.landscape-image {
						margin-bottom: 0;
					}
				}
			}
		}

		.description-and-image-wrap {
			.images-wrap {
				justify-content: flex-end;
				width: 100%;

				.big-img {
					margin-bottom: 8%;
				}
			}
		}
		.second-section {
			margin-top: calc(var(--sp46x) * -1);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--firstSectionMargin: var(--sp22x);
		--titleMarginBottom: var(--sp3x);
		--subtitleMarginBottom: var(--sp5x);
		--subtitleMaxWidth: var(--sp98x);
		--secondSectionPaddingTopBottom: var(--sp15x) 0;
		--descriptionMaxWidth: var(--sp52x);
		--descriptionSecondSectionFirstChild: var(--sp8x);
		--buttonMarginTop: var(--sp5x);

		--smallImageMarginRight: var(--sp5x);
		--leftContentMarginBottom: 0;
		--onlyFileMarginBottom: var(--sp13x);
		--smallLandscapeImagePaddingTop: 23.5%;

		--smallImageWidth: 31%;
		--smallImagePaddingTop: 37.3%;

		--bigImageWidth: 62.6%;
		--bigImagePaddingTop: 80%;

		.description-and-image-wrap {
			.images-wrap {
				.small-img {
					&.landscape-image {
						margin-bottom: 0;
					}
				}
			}
		}

		.description-and-image-wrap {
			.images-wrap {
				justify-content: flex-end;
				width: 100%;

				.big-img {
					margin-bottom: 7%;
				}
			}
		}
		.second-section {
			margin-top: calc(var(--sp33x) * -1);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--firstSectionMargin: var(--sp50x);
		--titleMarginBottom: var(--sp3x);
		--subtitleMarginBottom: var(--sp5x);
		--subtitleMaxWidth: 100%;
		--secondSectionPaddingTopBottom: var(--sp18x) 0;
		--descriptionMaxWidth: var(--sp70x);
		--descriptionSecondSectionFirstChild: 0;
		--buttonMarginTop: var(--sp5x);

		--smallImageWidth: 29.4%;
		--smallImagePaddingTop: 36.9%;
		--smallImageMarginRight: var(--sp5x);
		--bigImageWidth: 51.3%;
		--bigImagePaddingTop: 64.4%;
		--leftContentMarginBottom: 0;
		--onlyFileMarginBottom: var(--sp13x);
		--smallLandscapeImagePaddingTop: 28%;

		.description-and-image-wrap {
			.images-wrap {
				.small-img {
					&.landscape-image {
						margin-bottom: 0;
					}
				}
			}
		}

		.left-content {
			&.no-button {
				margin-bottom: var(--sp5x);
			}
		}

		.description-and-image-wrap {
			flex-direction: column;
			.images-wrap {
				justify-content: flex-end;
				width: 100%;

				.big-img {
					margin-bottom: 8%;
				}

				&.has-description {
					margin-top: var(--sp3x);
				}
			}
		}

		.second-section-descriptions-wrap {
			flex-direction: column;
			.description-second-section {
				&:first-child {
					margin-bottom: var(--sp3x);
				}
			}
		}
		.second-section {
			margin-top: calc(var(--sp60x) * -1);
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--firstSectionMargin: var(--sp40x);
		--titleMarginBottom: var(--sp3x);
		--subtitleMarginBottom: var(--sp4x);
		--subtitleMaxWidth: 100%;
		--secondSectionPaddingTopBottom: var(--sp15x) 0;
		--descriptionMaxWidth: 100%;
		--descriptionSecondSectionFirstChild: 0;
		--buttonMarginTop: var(--sp5x);

		--smallImageWidth: 33.5%;
		--smallImagePaddingTop: var(--sp21x);
		--smallImageMarginRight: var(--sp2x);
		--bigImageWidth: calc(100% - 33.5% - var(--smallImageMarginRight));
		--bigImagePaddingTop: var(--sp36x);
		--leftContentMarginBottom: 0;
		--onlyFileMarginBottom: var(--sp12x);
		--smallLandscapeImagePaddingTop: 28%;

		.description-and-image-wrap {
			.images-wrap {
				.small-img {
					&.landscape-image {
						margin-bottom: 0;
					}
				}
			}
		}

		.description-and-image-wrap {
			flex-direction: column;
			.images-wrap {
				justify-content: flex-end;
				margin-top: var(--sp8x);
				width: 100%;

				&.no-second-section {
					margin-top: var(--sp8x);
				}

				.big-img {
					margin-bottom: var(--sp7x);
				}
			}
		}

		.second-section-descriptions-wrap {
			flex-direction: column;
			.description-second-section {
				&:first-child {
					margin-bottom: var(--sp3x);
				}
			}
		}
		.second-section {
			margin-top: calc(var(--sp51x) * -1);
		}

		.full-width-image-video {
			--fullWidthImagePaddingTop: 71.988%;
		}
	}
`;

export default DescriptiveStyle;
